import { useState } from 'react';
import { getSavedTheme, setThemeColor, resetTheme, THEME_DEFAULTS } from '../../hooks/useTheme';
import './ThemeCustomizer.css';

// Cores principais pré-definidas (a cor principal não é mais livre — só estas)
const MAIN_COLOR_PRESETS = [
  { label: 'Roxo', value: '#6439c9' },
  { label: 'Verde', value: '#22c55e' },
  { label: 'Vermelho', value: '#ef4444' },
  { label: 'Azul', value: '#3b82f6' },
  { label: 'Amarelo', value: '#eab308' },
  { label: 'Rosa', value: '#ec4899' },
];

export default function ThemeCustomizer() {
  const [colors, setColors] = useState(getSavedTheme);
  const [justReset, setJustReset] = useState(false);

  function handleChange(variable, value) {
    setColors((prev) => ({ ...prev, [variable]: value }));
    setThemeColor(variable, value);
  }

  function handleReset() {
    resetTheme();
    setColors({ ...THEME_DEFAULTS });
    setJustReset(true);
    setTimeout(() => setJustReset(false), 1500);
  }

  return (
    <div className="stat-card-profile theme-customizer lg:flex-1">
      <div className="theme-head">
        <span className="theme-head-title">
          <i className="fas fa-swatchbook" /> Aparência
        </span>
        <button
          type="button"
          className="theme-reset-btn"
          onClick={handleReset}
          title="Restaurar padrões"
        >
          {justReset ? <><i className="fas fa-check" /> Restaurado</> : <><i className="fas fa-undo" /> Restaurar</>}
        </button>
      </div>

      <div className="theme-controls">
        {/* Fundo — color picker livre */}
        <div className="theme-control">
          <span className="theme-control-label">
            <i className="fas fa-fill-drip" /> Fundo
          </span>
          <label className="theme-bg-field" style={{ background: colors['--bg-primary'] }}>
            <input
              type="color"
              value={colors['--bg-primary']}
              onChange={(e) => handleChange('--bg-primary', e.target.value)}
              className="theme-color-input"
              title="Fundo Principal"
            />
            <span className="theme-bg-hex">{(colors['--bg-primary'] || '').toUpperCase()}</span>
          </label>
        </div>

        {/* Cor principal — apenas presets */}
        <div className="theme-control">
          <span className="theme-control-label">
            <i className="fas fa-palette" /> Cor principal
          </span>
          <div className="theme-swatches">
            {MAIN_COLOR_PRESETS.map(({ label, value }) => {
              const active = (colors['--purple'] || '').toLowerCase() === value.toLowerCase();
              return (
                <button
                  key={value}
                  type="button"
                  title={label}
                  aria-label={label}
                  onClick={() => handleChange('--purple', value)}
                  className={`theme-swatch ${active ? 'is-active' : ''}`}
                  style={{ background: value }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
